import {
    DISCOVERY_TYPES_OPTIONS,
    DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS, EMPLOYMENT_STATUS_OPTIONS,
    MARITAL_STATUS_OPTIONS, EMPLOYMENT_STATUS_REQUIRING_OCCUPATION_OPTIONS,
    TITLE_OPTIONS, YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import ObjetDataValidator from "@anjan011/object-data-validator";
import {transformValidationResultToArray} from "@utils/validation-markup-generator";

const isEmployed = (data) => {
    return ['Employed', 'Self-Employed'].includes(data.employmentStatus);
};

export const ValidateStep1Data = (data) => {

    let nameMaxLen = 50;
    let nameAddressLen = 100;

    let titleValues = TITLE_OPTIONS?.map((item) => {
        return item.value
    });

    const rules = [
        {
            field_name: 'title',
            field_label: 'Title',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: titleValues
                    },
                    message: 'Invalid title: {value}'
                }
            ]
        },
        {
            field_name: 'firstName',
            field_label: 'First name',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {
                        length: nameMaxLen
                    },
                    message: `First name cannot be longer than {length} characters`
                }
            ]
        },
        {
            field_name: 'lastName',
            field_label: 'Last name',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {
                        length: nameMaxLen
                    },
                    message: `Last name cannot be longer than {length} characters`
                }
            ]
        },
        {
            field_name: 'birthDate',
            field_label: 'Birth date',
            rules: [
                {name: 'required'},
                {
                    name: 'date_string',
                    data: {
                        format: 'yyyy-MM-dd',
                    },
                    message: `Invalid birth date {value}`
                },
            ]
        },
        {
            field_name: 'houseNumber',
            field_label: 'House number',
            rules: [
                {name: 'required'},
                {name: 'string'},
            ]
        },
        {
            field_name: 'addressLine1',
            field_label: 'Street address',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {length: nameAddressLen},
                    message: `Street address cannot be longer than {length} characters`
                }
            ]
        },
        {
            field_name: 'addressLine2',
            field_label: 'Address line 2',
            rules: [
                {name: 'nullable'},
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {length: nameAddressLen},
                    message: `Address line 2 cannot be longer than {length} characters`
                }

            ]
        },
        {
            field_name: 'postCode',
            field_label: 'Post code',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {name: 'max_length', data: {length: 10}}
            ]
        },
        {
            field_name: 'maritalStatus',
            field_label: 'Marital status',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {name: 'max_length', data: {length: 50}},
                {
                    name: 'in_array', data: {
                        array: MARITAL_STATUS_OPTIONS?.map((item) => {
                            return item.value;
                        })
                    },
                    message: `Invalid marital status {value}`
                }
            ],
        },
        {
            field_name: 'employmentStatus',
            field_label: 'Employment status',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {name: 'max_length', data: {length: 50}},
                {
                    name: 'in_array', data: {
                        array: EMPLOYMENT_STATUS_OPTIONS?.map((item) => {
                            return item.value;
                        })
                    },
                    message: `Invalid employment status {value}`
                }
            ]

        },
        {
            field_name: 'isHomeOwner',
            field_label: 'Is home owner',
            rules: [
                {
                    name: 'required',
                    message: `Please specify if you are a home owner or not`
                },
                {
                    name: 'string',
                    message: `Invalid value for home owner status`
                },
                {
                    name: 'in_array', data: {
                        array: YES_NO_CHOICE_OPTIONS?.map((item) => {
                            return item.value;
                        })
                    },
                    message: `For home owner status please select either Yes or No`
                }
            ]
        },
        {
            field_name: 'hasChildrenUnder16',
            field_label: 'Has children under 16',
            rules: [
                {
                    name: 'required',
                    message: `Please specify if you have children under 16 or not`
                },
                {
                    name: 'string',
                    message: `Invalid value for children under 16 status`
                },
                {
                    name: 'in_array', data: {
                        array: YES_NO_CHOICE_OPTIONS?.map((item) => {
                            return item.value;
                        })
                    },
                    message: `For children under 16 status please select either Yes or No`
                }
            ]

        },
        {
            field_name: 'mainOccupation',
            field_label: 'Main occupation',
            rules: [
                {
                    name: 'required_if_target_in_array',
                    data: {
                        target_field: 'employmentStatus',
                        array: EMPLOYMENT_STATUS_REQUIRING_OCCUPATION_OPTIONS
                    },
                    message : `Please provide your main occupation`
                },
                {name: 'string'},
                {name: 'max_length', data: {length: 100}}
            ]
        },
        {
            field_name: 'occupationIndustry',
            field_label: 'Occupation industry',
            rules: [
                {
                    name: 'required_if_target_in_array',
                    data: {
                        target_field: 'employmentStatus',
                        array: EMPLOYMENT_STATUS_REQUIRING_OCCUPATION_OPTIONS
                    },
                    message : `Please provide your occupation industry`
                },
                {name: 'string'},
                {name: 'max_length', data: {length: 100}}
            ]
        }
    ];

    const validator = new ObjetDataValidator({
        data,
        rules
    });

    const result = validator.validate();

    if (result === true) {
        return [];
    } else {
        return transformValidationResultToArray(result);
    }

}